<div class="cart-container">



  <div class="cart-items">
    @for (item of cartStore.cart(); track item.cartLineItemId) {
      <div class="cart-item-card">
        <div class="image-container">
          <img [src]="item.imageUrl" alt="producto" class="item-image">
        </div>

        <div class="item-info">
          <div class="top-section">
            <h3 class="product-name text-h3">{{ item.name }}</h3>
            <button (click)="removeItem(item.cartLineItemId)" class="remove-btn">
              <svg lucideTrash2></svg>
            </button>
          </div>

          <p class="product-notes">{{ item.notes }}</p>

          <div class="bottom-section">
            <span class="product-price text-price">
              {{ (parsePrice(item.price) * item.quantity) | clpFormat }}
            </span>

            <div class="quantity-controls">
              <button (click)="changeQty(item.cartLineItemId, -1)"
                      [disabled]="item.quantity <= 1"
                      class="qty-btn minus">
                <svg lucideMinus></svg>
              </button>

              <span class="qty-text">{{ item.quantity }}</span>

              <button (click)="changeQty(item.cartLineItemId, 1)"
                      class="qty-btn plus">
                <svg lucidePlus></svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    } @empty {
      <div class="empty-state">
        <svg class="empty-icon" lucideShoppingBag></svg>
        <p class="text-body">Tu carrito está vacío</p>
      </div>
    }
  </div>

  @if (cartStore.cart().length > 0) {
    <footer class="view-footer anim-slide-in-up">
      <button (click)="confirmOrder()"
              [disabled]="cartStore.isCartLoading()"
              class="btn-main accent"
              mat-flat-button>
        @if (cartStore.isCartLoading()) {
          <mat-spinner diameter="24"></mat-spinner>
        } @else {
          Confirmar Pedido
        }
      </button>
    </footer>
  }
</div>
